import { Controller } from "@hotwired/stimulus"

// Fires one Meta Pixel event, declared entirely via data attributes so views never touch
// window.fbq/SpicyPixel directly. All event data (price, currency, ids) comes from the
// server - this controller only decides when to fire.
//   data-controller="meta-event"
//   data-meta-event-name-value="ViewContent"
//   data-meta-event-params-value='{"content_ids":["filter-75"], ...}'
//   data-meta-event-on-connect-value="true"   (ViewContent: fires once the element appears)
// An action event (AddToCart, InitiateCheckout) instead fires from an explicit data-action,
// e.g. data-action="turbo:submit-end->meta-event#fireOnSuccess" or "submit->meta-event#fire".
export default class extends Controller {
  static values = { name: String, params: Object, eventId: String, onConnect: Boolean }

  connect() {
    if (this.onConnectValue) this.fire()
  }

  fire() {
    window.SpicyPixel?.track(this.nameValue, this.paramsValue, this.eventIdValue || null)
  }

  // For a Turbo Stream form submission (e.g. "Add to cart"): only on a successful response.
  fireOnSuccess(event) {
    if (event.detail?.success) this.fire()
  }
}
